module.exports = __webpack_public_path__ + "static/media/191.4912a2bd.jpg";